import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import Layout from '@/common/Layout'
import { queryClient } from '@/common/lib/queryClient'
import { Routing } from './routing'
import { useYandexMetrica } from '@/common/lib/yandexMetrica'
import { useCloseModalsOnRouteChange } from '@/common/hooks/useCloseModalsOnRouteChange'

const App = () => {
    const { isEnabled } = useYandexMetrica()
    useCloseModalsOnRouteChange()

    return (
        <Layout>
            <QueryClientProvider client={queryClient}>
                <>
                    <Routing />
                    <ReactQueryDevtools initialIsOpen={false} />
                    {isEnabled && (
                        <noscript>
                            <div>
                                <img
                                    src={`https://mc.yandex.ru/watch/${__YANDEX_METRICA_ID__}`}
                                    style={{ position: 'absolute', left: '-9999px' }}
                                    alt=''
                                />
                            </div>
                        </noscript>
                    )}
                </>
            </QueryClientProvider>
        </Layout>
    )
}

export default App
